import React from "react";
import CommingSoon from "../../Components/layouts/comming.soon";

const Free3MonthsReplacement = () => {
  return <CommingSoon />;
};

export default Free3MonthsReplacement;
